import type { BikeModel } from '../../api/types';
import { tk } from '../../i18n';

export type Section = 'general' | 'ficha' | 'colores' | 'especiales' | 'galeria' | 'documentos';

/** Las pestañas del editor (las etiquetas se traducen con t() al mostrarlas). */
export const SECTIONS: { id: Section; label: string }[] = [
  { id: 'general', label: tk('General') },
  { id: 'ficha', label: tk('Ficha técnica') },
  { id: 'colores', label: tk('Colores y 360') },
  { id: 'especiales', label: tk('Especiales') },
  { id: 'galeria', label: tk('Galería y claim') },
  { id: 'documentos', label: tk('Documentos') },
];

/** Largos máximos (los mismos que valida la API en src/catalog/model.schemas.ts). */
export const LIMITS = {
  name: 14,
  headline: 60,
  subtitle: 90,
  category: 60,
  seoDescription: 200,
  heroAlt: 160,
  priceNote: 60,
  claimLine: 28,
  especialesParagraph: 450,
  especialesParagraphs: 3,
  gears: 8,
  colors: 6,
  frames: 72,
  // En escritorio la lista de especiales tiene lugar para 14 (la sección del diseño es de alto fijo).
  specials: 14,
  specialName: 40,
  gallery: 16,
  caption: 100,
} as const;

export interface TabProps {
  model: BikeModel;
  onSaved: (model: BikeModel) => void;
  onDirty: (dirty: boolean) => void;
}

/** "8,4" → 8.4 · "" → null */
export function parseNumber(value: string): number | null {
  const v = value.trim().replace(',', '.');
  if (!v) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : NaN;
}

export const numberText = (n: number | null) => (n == null ? '' : String(n).replace('.', ','));
